export default __webpack_public_path__ + "static/AppInterview2-c3996590c38c3072d15bb326751613c3.png";